import React from 'react';
import { NavLink } from 'react-router-dom';

import './NavBar.css';

class NavBar extends React.Component {
  render() {
    const pages = ['Work', 'Skills'];
    const navLinks = pages.map((page, i) => {
      return (
        <NavLink className='nav-item' to={'/' + page} key={i} activeClassName="active">
          {page}
        </NavLink>
      )
    });

    return <nav className='nav'>{navLinks}</nav>;
  }
}

export default NavBar;



// WEBPACK FOOTER //
// ./src/Shared/NavBar.js